export default "/imgs/bnr-1.jpg"